export default function returnToJL(fragment: 'homepage' | 'basket' = 'homepage'): string {
  return `${window.publicJLSiteDomain}/#${fragment}`;
}
